// Site data: doctor profile, hospital info, team, treatments, gallery
import {
  Bone, Activity, HandMetal, Baby, Microscope, Zap, HeartPulse, Stethoscope,
  ShieldPlus, Trophy, Hospital, Cross, ScanLine, Pill, Wind, Phone,
} from "lucide-react";

export const DOCTOR = {
  name: "Dr. Kamal Kishore",
  title: "Orthopaedic & Joint Replacement Surgeon",
  qualifications: "MBBS – IGIMS Patna · MS Orthopaedics – PMCH Patna",
  experience: "20+ Years",
  surgeries: "10,000+",
  successRate: "98.5%",
  hospital: "Aastha Maternity & Ortho Care Centre",
  city: "Sasaram, Bihar",
  phone: "+91 7461001038",
  phoneRaw: "7461001038",
  whatsapp: "7260917973",
  email: "contact@aasthaorthocare.in",
  address: "Behind Hotel Ashirvad International, Grand Trunk Road, Navaratan Bazar, Laxkariganj, Sasaram, Bihar – 821115",
  languages: ["Hindi", "English", "Bhojpuri", "Urdu"],
  photo: "https://customer-assets.emergentagent.com/job_ortho-excellence-5/artifacts/czrs7c3m_WhatsApp%20Image%202026-07-08%20at%2011.14.44%20PM.jpeg",
  bio: "Dr. Kamal Kishore is a highly respected Joint Replacement Surgeon, Sports Injury Specialist and Pediatric Orthopedic Surgeon serving the Sasaram region for over two decades. Trained at IGIMS Patna and PMCH Patna, he has built Aastha Maternity & Ortho Care Centre into a trusted destination for advanced bone, joint and trauma care — combining international clinical protocols with warm, personalised patient attention.",
  degrees: [
    "MBBS — Indira Gandhi Institute of Medical Sciences (IGIMS), Patna",
    "MS Orthopedics — Patna Medical College & Hospital (PMCH), Patna",
    "Fellowship — Joint Replacement Surgery",
    "Advanced Training — Sports Injury & Pediatric Orthopedics",
  ],
  awards: [
    "Distinguished Orthopedic Surgeon — Bihar Ortho Society",
    "Excellence in Joint Replacement — Regional Medical Forum",
    "Community Service Award — Sasaram Medical Association",
    "Best Ortho Care Centre — Aastha Hospital Recognition",
  ],
  memberships: [
    "Indian Orthopedic Association (IOA)",
    "Bihar Orthopedic Association",
    "Indian Arthroscopy Society",
    "Indian Society of Hip & Knee Surgeons",
  ],
};

// Additional appointment / contact numbers
export const CONTACT_NUMBERS = [
  { label: "Primary / Appointments", number: "+91 7461001038", raw: "7461001038", primary: true },
  { label: "Reception", number: "+91 8409565556", raw: "8409565556" },
  { label: "OPD Desk", number: "+91 7461001038", raw: "7461001038" },
  { label: "Emergency", number: "+91 9431410659", raw: "9431410659" },
];

// Team of doctors at Aastha Maternity & Ortho Care Centre
export const TEAM_DOCTORS = [
  {
    id: "d1",
    name: "Dr. Kamal Kishore",
    role: "Orthopaedic & Joint Replacement Surgeon",
    qualifications: "MBBS – IGIMS Patna, MS Orthopaedics – PMCH Patna",
    experience: "20+ Years",
    photo: "https://customer-assets.emergentagent.com/job_ortho-excellence-5/artifacts/czrs7c3m_WhatsApp%20Image%202026-07-08%20at%2011.14.44%20PM.jpeg",
  },
  {
    id: "d2",
    name: "Dr. Anil Kumar",
    role: "Consultant Orthopaedic Surgeon",
    qualifications: "MS Orthopaedics",
    experience: "25+ Years",
    photo: "https://customer-assets.emergentagent.com/job_ortho-excellence-5/artifacts/ypfia6rq_WhatsApp%20Image%202026-07-08%20at%2011.13.18%20PM.jpeg",
  },
  {
    id: "d3",
    name: "Dr. Riya Nandini",
    role: "Obstetrician & Gynaecologist",
    qualifications: "MBBS, DGO",
    experience: "Consultant",
    photo: "https://customer-assets.emergentagent.com/job_ortho-excellence-5/artifacts/hjmutt9p_WhatsApp%20Image%202026-07-08%20at%2011.15.05%20PM.jpeg",
  },
];

// Detailed profiles rendered below the About Dr. Kamal Kishore section
export const TEAM_PROFILES = [
  {
    id: "anil-kumar",
    name: "Dr. Anil Kumar",
    overline: "About Dr. Anil Kumar",
    headlinePre: "Decades of ",
    headlineEm: "trusted expertise",
    headlinePost: ".",
    title: "Consultant Orthopaedic Surgeon",
    stat: "25",
    statSup: "+",
    statLabel: "Years of dedicated orthopaedic practice",
    photo: "https://customer-assets.emergentagent.com/job_ortho-excellence-5/artifacts/ypfia6rq_WhatsApp%20Image%202026-07-08%20at%2011.13.18%20PM.jpeg",
    bio: "Dr. Anil Kumar is a senior Consultant Orthopaedic Surgeon with more than 25 years of experience in diagnosing and treating bone, joint and trauma-related conditions. He specializes in fracture management, arthritis treatment, sports injuries, joint preservation and advanced orthopaedic procedures. He is committed to evidence-based treatment, compassionate patient care and excellent surgical outcomes.",
    degrees: [
      "MS Orthopaedics",
      "Consultant Orthopaedic Surgeon",
      "Advanced Trauma Care",
      "Joint Preservation Specialist",
      "Fracture Management",
      "Arthritis Treatment",
    ],
    memberships: [
      "Indian Orthopaedic Association (IOA)",
      "Bihar Orthopaedic Association",
      "Trauma Society of India",
      "Orthopaedic Surgeons Association",
    ],
    languages: ["Hindi", "English", "Bhojpuri"],
  },
  {
    id: "riya-nandini",
    name: "Dr. Riya Nandini",
    overline: "About Dr. Riya Nandini",
    headlinePre: "Caring for ",
    headlineEm: "every woman",
    headlinePost: ", at every stage.",
    title: "Obstetrician & Gynaecologist",
    stat: "OBG",
    statSup: "",
    statLabel: "Consultant Obstetrician & Gynaecologist",
    photo: "https://customer-assets.emergentagent.com/job_ortho-excellence-5/artifacts/hjmutt9p_WhatsApp%20Image%202026-07-08%20at%2011.15.05%20PM.jpeg",
    bio: "Dr. Riya Nandini is an experienced Obstetrician and Gynaecologist providing comprehensive care for women at every stage of life. She specializes in pregnancy care, infertility management, high-risk pregnancy, menstrual disorders, PCOS, adolescent health and minimally invasive gynaecological procedures. She is dedicated to providing compassionate, ethical and personalized women's healthcare.",
    degrees: [
      "MBBS – NMCH",
      "DGO – Nanavati Hospital, Mumbai",
      "Ex Resident – AIIMS New Delhi",
      "Fellowship in Infertility – Sarogi Hospital",
    ],
    memberships: [
      "Federation of Obstetric and Gynaecological Societies of India (FOGSI)",
      "Indian Medical Association (IMA)",
      "Bihar Obstetrics & Gynaecology Association",
    ],
    languages: ["Hindi", "English"],
  },
];

export const TREATMENTS = [
  { slug: "knee-replacement", icon: Bone, title: "Knee Replacement", desc: "Total & partial knee replacement with rapid recovery protocols." },
  { slug: "hip-replacement", icon: Bone, title: "Hip Replacement", desc: "Modern hip arthroplasty for minimal scarring and quick mobility." },
  { slug: "shoulder-surgery", icon: Activity, title: "Shoulder Surgery", desc: "Rotator cuff repair, arthroscopy and shoulder reconstruction." },
  { slug: "spine-surgery", icon: ScanLine, title: "Spine Surgery", desc: "Minimally invasive spine procedures and decompression." },
  { slug: "trauma-surgery", icon: Zap, title: "Trauma Surgery", desc: "Complex fracture management and polytrauma reconstruction." },
  { slug: "fracture-treatment", icon: Cross, title: "Fracture Treatment", desc: "Conservative & operative care for all fracture types." },
  { slug: "arthroscopy", icon: Microscope, title: "Arthroscopy", desc: "Keyhole surgery for knee, shoulder, hip and ankle joints." },
  { slug: "sports-injury", icon: HeartPulse, title: "Sports Injury", desc: "ACL, PCL, meniscus and tendon repairs for athletes." },
  { slug: "pediatric-ortho", icon: Baby, title: "Pediatric Orthopedics", desc: "Child-friendly correction of congenital & developmental issues." },
  { slug: "bone-tumor", icon: ShieldPlus, title: "Bone Tumor Surgery", desc: "Limb-saving oncologic resections with reconstruction." },
  { slug: "ligament-reconstruction", icon: Activity, title: "Ligament Reconstruction", desc: "Anatomic ACL/PCL reconstruction using autografts." },
  { slug: "hand-surgery", icon: HandMetal, title: "Hand Surgery", desc: "Microsurgical hand, wrist and peripheral nerve repair." },
];

export const FACILITIES = [
  { icon: HeartPulse, label: "Advanced ICU" },
  { icon: ScanLine, label: "Digital X-Ray" },
  { icon: Microscope, label: "MRI Support" },
  { icon: ScanLine, label: "CT Scan Support" },
  { icon: Activity, label: "Physiotherapy" },
  { icon: Hospital, label: "Modular OT" },
  { icon: ShieldPlus, label: "Cashless Insurance" },
  { icon: Cross, label: "24×7 Ambulance" },
  { icon: Pill, label: "In-house Pharmacy" },
  { icon: Wind, label: "Private Rooms" },
  { icon: Phone, label: "Telemedicine" },
  { icon: Stethoscope, label: "Maternity Care" },
];

export const INSURANCE_PARTNERS = [
  "Star Health", "HDFC Ergo", "Bajaj Allianz", "ICICI Lombard",
  "Tata AIG", "Aditya Birla", "Max Bupa", "New India Assurance",
];

export const TROPHIES = [
  { icon: Trophy, label: "10,000+ Surgeries" },
  { icon: ShieldPlus, label: "98.5% Success Rate" },
  { icon: Hospital, label: "20+ Years Experience" },
];

export const FALLBACK_TESTIMONIALS = [
  { id: "t1", name: "Mrs. Sushma Devi", age: 64, rating: 5, story: "I could barely walk before my bilateral knee replacement at Aastha. Within two weeks I was climbing stairs without pain. Dr. Kamal Kishore gave me my life back.", surgery: "Bilateral Knee Replacement", visit_date: "2024-08-12" },
  { id: "t2", name: "Mr. Arjun Prasad", age: 42, rating: 5, story: "ACL reconstruction after a cricket injury — back on the field in 6 months. The Aastha team was exceptional.", surgery: "ACL Reconstruction", visit_date: "2024-06-04" },
  { id: "t3", name: "Mr. Vikram Singh", age: 71, rating: 5, story: "Hip replacement went smoother than I imagined. Walking with my grandchildren again is priceless.", surgery: "Hip Replacement", visit_date: "2024-09-22" },
];

export const FALLBACK_GALLERY = [
  { id: "g1", title: "Modular Operation Theatre", category: "Hospital", image_url: "https://images.unsplash.com/photo-1551076805-e1869033e561?w=800" },
  { id: "g3", title: "Patient Consultation", category: "Doctor", image_url: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800" },
  { id: "g5", title: "Physiotherapy Suite", category: "Hospital", image_url: "https://images.unsplash.com/photo-1540205895360-4ad4cffb3aa8?w=800" },
  { id: "g8", title: "Recovery Ward", category: "Hospital", image_url: "https://images.unsplash.com/photo-1538108149393-fbbd81895907?w=800" },
];
